// Author thq
// Date 2024-05-21 18:30:16

class EmAcctHandleRecordAhr {
    constructor({
                    id = null,
                    acctName = '',
                    acctNameBda = '',
                    acctIdBda = '',
                    acctStartDate = '',
                    acctEndDate = '',
                    acctReason = '',
                    acctIdDept = '',
                    acctNameDept = '',
                    acctIdAcl = '',
                    acctIdAct = '',
                    acctCode = '',
                    acctHandler = '',
                    acctPrecaution = '',
                    acctContent = '',
                    acctAttachment = '',
                    acctAttachmentList = ''
                }
                    = {}) {
        this.id = id;
        this.acctName = acctName;
        this.acctNameBda = acctNameBda;
        this.acctIdBda = acctIdBda;
        this.acctStartDate = acctStartDate;
        this.acctEndDate = acctEndDate;
        this.acctReason = acctReason;
        this.acctIdDept = acctIdDept;
        this.acctNameDept = acctNameDept;
        this.acctIdAcl = acctIdAcl;
        this.acctIdAct = acctIdAct;
        this.acctCode = acctCode;
        this.acctHandler = acctHandler;
        this.acctPrecaution = acctPrecaution;
        this.acctContent = acctContent;
        this.acctAttachment = acctAttachment;
        this.acctAttachmentList = acctAttachmentList;
    }
}

function newEntity() {
    return new EmAcctHandleRecordAhr();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'acctName',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.acctName',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'acctIdBda',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.acctIdBda',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'acctCodeBda',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.acctCodeBda',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'acctNameBda',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.acctNameBda',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'acctNameAcl',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.acctNameAcl',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'acctNameAct',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.acctNameAct',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'acctStartDate',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.acctStartDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'acctEndDate',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.acctEndDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'acctDuration',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.acctDuration',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'acctReason',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.acctReason',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'acctContent',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.acctContent',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'acctHandler',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.acctHandler',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'acctNameDept',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.acctNameDept',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isAndonTask',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.isAndonTask',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'andonTaskId',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.andonTaskId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'acctAttachmentList',
            label: 'label.em.accident.emAcctHandleRecordAhr.grid.acctAttachmentList',
            sortable: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    acctNameFilter: '',
    acctCodeBdaFilter: '',
    acctIdBdaFilter: '',
    acctDateRteFilter: '',
    acctDateLteFilter: '',
    acctReasonFilter: '',
    acctIdDeptFilter: '',
    acctNameDeptFilter: '',
    acctIdAclFilter: '',
    acctIdActFilter: '',
    acctCodeFilter: '',
    acctHandlerFilter: '',
    isAndonTaskFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'acctNameFilter',
        label: 'label.em.accident.emAcctHandleRecordAhr.filter.acctName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'acctCodeBdaFilter',
        label: 'label.em.accident.emAcctHandleRecordAhr.filter.acctCodeBda',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'acctIdBdaFilter',
        label: 'label.em.accident.emAcctHandleRecordAhr.filter.acctIdBda',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emArchBasicData'
            , correspondingField: 'id'
        }
    },
    {
        key: 'acctDateRteFilter',
        label: 'label.em.accident.emAcctHandleRecordAhr.filter.acctDateRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'acctDateLteFilter',
        label: 'label.em.accident.emAcctHandleRecordAhr.filter.acctDateLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'acctReasonFilter',
        label: 'label.em.accident.emAcctHandleRecordAhr.filter.acctReason',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'acctNameDeptFilter',
        label: 'label.em.accident.emAcctHandleRecordAhr.filter.acctNameDept',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclDept'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"acctIdDept":"id"}'
        }
    },
    {
        key: 'acctIdAclFilter',
        label: 'label.em.accident.emAcctHandleRecordAhr.filter.acctIdAcl',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAcctLevel'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'acctIdActFilter',
        label: 'label.em.accident.emAcctHandleRecordAhr.filter.acctIdAct',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAcctType'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'acctHandlerFilter',
        label: 'label.em.accident.emAcctHandleRecordAhr.filter.acctHandler',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
        }
    },
    {
        key: 'isAndonTaskFilter',
        label: 'label.em.accident.emAcctHandleRecordAhr.filter.isAndonTask',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'acctName',
        label: 'label.em.accident.emAcctHandleRecordAhr.entity.acctName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'acctNameBda',
        label: 'label.em.accident.emAcctHandleRecordAhr.entity.acctNameBda',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , required: true
            , entity: 'emArchBasicData'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"acctIdBda":"id"}'
        }
    },
    {
        key: 'acctStartDate',
        label: 'label.em.accident.emAcctHandleRecordAhr.entity.acctStartDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'acctEndDate',
        label: 'label.em.accident.emAcctHandleRecordAhr.entity.acctEndDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'acctReason',
        label: 'label.em.accident.emAcctHandleRecordAhr.entity.acctReason',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'acctNameDept',
        label: 'label.em.accident.emAcctHandleRecordAhr.entity.acctNameDept',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclDept'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"acctIdDept":"id"}'
        }
    },
    {
        key: 'acctIdAcl',
        label: 'label.em.accident.emAcctHandleRecordAhr.entity.acctIdAcl',
        sortable: true,
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , required: true
            , entity: 'emAcctLevel'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'acctIdAct',
        label: 'label.em.accident.emAcctHandleRecordAhr.entity.acctIdAct',
        sortable: true,
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , required: true
            , entity: 'emAcctType'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'acctHandler',
        label: 'label.em.accident.emAcctHandleRecordAhr.entity.acctHandler',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
        }
    },
    {
        key: 'acctContent',
        label: 'label.em.accident.emAcctHandleRecordAhr.entity.acctContent',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'acctAttachmentList',
        label: 'label.em.accident.emAcctHandleRecordAhr.entity.acctAttachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'acctAttachment'
        }
    }
]

export {
    EmAcctHandleRecordAhr, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
